/* eslint-disable */
<template>
    <div class="ma-0 pa-0">
        <BasicCard :show_title="false" class="mt-n1">
            <div>
                <v-container>
                    <v-row no-gutters class="mb-4">
                        <v-col cols="12" class="d-flex justify-end">
                            <span>
                                <div v-can="{obj_type:'operation', action: 'edit'}">
                                    <v-btn v-if="enable_ops" color="action" class="ml-2" @click.stop="newOperation"><v-icon small class="pr-1">add_box</v-icon>nuovo intervento</v-btn>
                                </div>
                                <v-btn color="action" class="ml-2" @click.stop="editInstrument(null)"><v-icon small class="pr-1">add_box</v-icon>strumento</v-btn>
                            </span>
                        </v-col>
                    </v-row>
                    <div v-if="advanced_search">
                    <v-divider />
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center">
                            <span class="text-h6">Ricerca avanzata</span>
                            <span><v-btn fab small text @click.stop="cancelSearch()"><v-icon>close</v-icon></v-btn></span>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="4" v-if="!lock_client" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="cliente"
                                v-model="filter.client_id"
                                :items="clients"
                                item-value="_id"
                                item-text="value.name"
                                clearable
                                @change="updateClient"></v-autocomplete>
                        </v-col>
                        <v-col cols="4" v-if="locations.length > 0 || (!lock_client && filter.client_id)" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                    label="sede"
                                    v-model="filter.location_id"
                                    :items="locations"
                                    item-value="_id"
                                    item-text="value.name"
                                    clearable
                                    @change="getDepartments"
                                ></v-autocomplete>
                        </v-col>
                        <v-col v-if="departments.length > 0" cols="4" class="d-flex justify-start align-content-center">
                            <v-autocomplete dense outlined
                                    label="reparto"
                                    v-model="filter.department_id"
                                    :items="departments"
                                    item-value="id"
                                    item-text="name"
                                    clearable
                                ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="6" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="ente"
                                v-model="filter.org"
                                :items="orgs"
                                item-value="id"
                                item-text="value.name"
                                clearable></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="6" class="d-flex justify-start align-content-center pr-2">
                            <v-combobox dense outlined
                                label="provincia"
                                v-model="filter.district"
                                :items="districts.districts"
                                item-value="id"
                                item-text="name"
                                return-object
                                clearable></v-combobox>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-start align-content-center">
                            <v-combobox dense outlined
                                    label="città"
                                    v-model="filter.city"
                                    :items="districts.cities"
                                    item-value="id"
                                    item-text="name"
                                    return-object
                                    clearable
                                ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-divider v-if="(lock_client && locations.length > 1) || !lock_client" class="my-2" />
                    <v-row no-gutters>
                        <v-col cols="4" class="d-flex justify-start align-content-center">
                            <v-autocomplete dense outlined
                                label="famiglia"
                                v-model="filter.search_family"
                                :items="Object.keys(families)"
                                @change="updateUoms"
                                multiple
                                clearable></v-autocomplete>
                        </v-col>
                        <!--v-col v-if="filter.search_family.length == 1" cols="8" class="d-flex flex-column justify-start align-content-center">
                            <div v-switch="filter.search_family[0]" >
                                <div v-case="`bilancia nawi`">
                                    <div class="d-flex fill-width justify-end pl-4">
                                    <span class="font-italic">portata massima</span>
                                    <v-autocomplete dense outlined
                                        label="unità di misura"
                                        class="pl-2"
                                        v-model="filter.uom"
                                        :items="fam_uoms"
                                        item-text="id"
                                        item-value="id"
                                        clearable></v-autocomplete>
                                    <NumericField dense outlined
                                        class="pl-2"
                                        label="da"
                                        v-model="filter.min"
                                        multiple
                                        clearable/>
                                    <NumericField dense outlined
                                        class="pl-2"
                                        label="a"
                                        v-model="filter.max"
                                        multiple
                                        clearable/>
                                    </div>
                                </div>
                                <div v-default>
                                    <div class="d-flex fill-width justify-end pl-4">
                                    <span class="font-italic">range funzionamento</span>
                                    <v-autocomplete dense outlined
                                        label="unità di misura"
                                        class="pl-2"
                                        v-model="filter.uom"
                                        :items="fam_uoms"
                                        item-text="id"
                                        item-value="id"
                                        clearable></v-autocomplete>
                                    <NumericField dense outlined
                                        class="pl-2"
                                        label="min"
                                        v-model="filter.min"
                                        multiple
                                        clearable/>
                                    <NumericField dense outlined
                                        class="pl-2"
                                        label="max"
                                        v-model="filter.max"
                                        multiple
                                        clearable/>
                                    </div>
                                </div>
                            </div>
                        </v-col-->
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="6" md="4" class="d-flex justify-start align-content-center">
                            <v-text-field dense outlined
                                label="seriale/marca/modello"
                                v-model="filter.search"
                                clearable></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="6" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="tipo report" 
                                :items="op_types"
                                item-value="id"
                                item-text="name"
                                v-model="filter.op_type"
                                clearable></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <div class="font-weight-bold">Data scadenza</div>
                        <v-col cols="12" class="d-flex flex-column">
                            <div class="d-flex justify-left full-width my-2">
                                <v-btn class="" @click="periodChange(0, 0)">oggi</v-btn>
                                <v-btn class="ml-2" @click="periodChange(1, 1)">ieri</v-btn>
                                <v-btn class="ml-2" @click="periodChange(6, 0)">ultimi 7 giorni</v-btn>
                                <v-btn class="ml-2" @click="periodChange(29, 0)">ultimi 30 giorni</v-btn>
                            </div>
                            <div class="d-flex mt-1">
                                <span><CalendarField
                                    v-model="filter.from"
                                    label="da"
                                    clearable>
                                </CalendarField></span>
                                <span class="pl-2"><CalendarField
                                    :minDate="filter.from"
                                    v-model="filter.to"
                                    label="a"
                                    clearable>
                                </CalendarField></span>
                            </div>
                        </v-col>
                    </v-row>
                    
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex justify-center align-content-center">
                            <v-btn color="primary" class="text-center" @click="search"><v-icon class="ma-2">search</v-icon>cerca</v-btn>
                            <v-btn color="action" class="text-center ml-2" @click="cancelSearch">annulla</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-4" />
                    </div>
                    <div v-if="filtered_org && !advanced_search">
                        <div class="text-h6">Ricerca tra tutti gli strumenti</div>
                        <v-row no-gutters>
                            <v-col cols="6"  class="d-flex justify-start align-content-center pr-2">
                                <v-text-field dense outlined
                                    label="seriale"
                                    v-model="search_serno"
                                    clearable
                                ></v-text-field>
                            </v-col>

                            <v-col cols="6" class="d-flex justify-start align-content-center">
                                <v-btn color="primary" class="d-flex align-content-center text-center" @click="exactSearch"><v-icon class="pr-2">search</v-icon>Cerca</v-btn>
                                <v-btn color="action" class="text-center ml-2" @click="cancelSearch">annulla</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider />
                    <v-row no-gutters>
                        <!--v-col cols="2" class="d-flex justify-end align-content-center">
                            <v-btn
                                color="action"
                                @click.stop="openFilter"
                                ><v-icon>filter_list</v-icon>Filtra</v-btn>
                        </v-col-->
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center mt-4">
                            <span><v-autocomplete dense outlined
                                    label="ordina per"
                                    v-model="sort_fields"
                                    :items="sorting_fields"
                                    item-value="value"
                                    item-text="label"
                                    return-object
                                    @change="changeOrder"
                                ></v-autocomplete>
                            </span>
                            <span v-if="!advanced_search">
                                <v-btn v-if="!(client_id && lock_client)" class="mr-2" color="primary" @click.stop="search_qr = true"><v-icon class="mr-2">qr_code</v-icon>cerca QR</v-btn>
                                <v-btn color="primary" @click.stop="openAdvancedSearch"><v-icon class="mr-2">filter_list</v-icon>filtra</v-btn>
                            </span>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
            <div v-if="!searching">
                <v-data-table
                    :items="objects"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    dense
                    hide-default-header
                    hide-default-footer
                    @page-count="pageCount = $event">
                    <template v-slot:body="{ items }">
                    <tbody >
                        <div v-if="objects.length == 0" class="px-2 text-h6 text-center">
                            Nessuno strumento trovato
                        </div>
                        <tr class="pa-0 ma-0" v-for="instr in items" :key="instr._id">
                            <td>
                                <InstrumentItem 
                                    :instrument_id="instr._id"
                                    :lock_client="lock_client"
                                    :show_client="!!!client_id"
                                    :show_location="true"
                                    :show_platform_capacity="true"
                                    @add_instrument="refreshInstrument"
                                    @instrument_removed="refreshInstrument"
                                    @update_instrument="updateInstrument">
                                    <template v-slot:other_action>
                                        <v-btn v-can="{obj_type: 'instrument', 'action': 'operation'}" color="primary" @click.stop="openOperationDialog(instr)" fab small><v-icon class="pa-2">access_time</v-icon></v-btn>
                                    </template>
                                </InstrumentItem>
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-data-table>
                <div v-if="objects.length > 0" class="text-center pa-2">
                    <div class="text-right font-italic font-small">Totale: {{ this.objects.length }}</div>
                    <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
                </div>
            </div>
            <div v-else>
                <v-card-text class="xs12 text-center">
                    <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
                </v-card-text>
            </div>
        </BasicCard>
        <InstrumentDialog
            ref="list_instrumentEdit"
            v-on:update_instrument="refreshInstrument"
        />
        <BaseDialog
        :dialog="op_dialog.open"
        v-on:close_dialog="closeOperationDialog"
        >
        <template v-slot:title>
            Scegli intervento
        </template>
        <div>
            <v-row no-gutters v-if="op_dialog.instr">
                <v-col cols="12">
                    <InstrumentItem 
                        :instrument_id="op_dialog.instr._id"
                        :show_client="!!!client_id"
                        :show_location="true"
                        :show_platform_capacity="false"
                        :can_change="false"
                        :disable_link="true"
                        />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-between">
                    <v-autocomplete v-if="w_ops.length > 0" dense outlined
                        label="interventi in corso"
                        v-model="op_dialog.op_id"
                        :items="w_ops"
                        item-value="_id"
                        :item-text="item => 'nr. '+item.value.order_nr +' del '+ formatDate(item.value.order_date)"
                        clearable
                        @change="updateClient"
                    ></v-autocomplete>
                    <v-spacer />
                    <v-btn color="action" class="ml-2" @click.stop="newOperation"><v-icon small class="ma-1">add_box</v-icon>nuovo intervento</v-btn>
                </v-col>
            </v-row>
            <div class="d-flex align-center justify-center" v-if="!op_dialog.updating">
                <v-btn :disabled="!op_dialog.op_id" class="ma-2" color="primary" @click.stop="saveOperation">aggiungi</v-btn>
                <v-btn class="ma-2" text @click.stop="closeOperationDialog">annulla</v-btn>
            </div>
            <div class="d-flex align-center justify-center" v-else>
                <span v-if="op_dialog.updated">
                    <v-btn class="ma-2" color="primary" @click.stop="editOperation">vai all'intervento</v-btn>
                    <v-btn class="ma-2" text @click.stop="closeOperationDialog">chiudi</v-btn>
                </span>
                <v-progress-circular v-else
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                ></v-progress-circular>
            </div>        
        </div>
    </BaseDialog>
    <SearchQR 
        :dialog="search_qr"
        @show_detail="goToInstrument"
        @close="closeQRSearchDialog"/>
    </div>
</template>

<script>
// import _ from 'lodash'
import BasicCard from "../../components/utils/Basic_card"
import BaseDialog from "../../components/dialogs/BaseDialog"
import SearchQR from "../../components/dialogs/SearchQR"
import InstrumentItem from "./InstrumentItem"
import {searchDesign, orderByFields, support_db} from "../../utils/dbUtility"
import {ListManagement} from "../../utils/listMixin"
import InstrumentDialog from "./InstrumentDialog"
import {i_families, report_type} from "../../utils/common.js"
import { subDays, startOfDay, endOfDay } from 'date-fns'
import { formatDatefromTS } from '../../utils/commonUtils'
import { filterByOrg, useRemoteConnection } from '../../utils/rolesManagement'

export default {
    components: {BasicCard, InstrumentItem, InstrumentDialog, BaseDialog, SearchQR},
    mixins: [ListManagement],
    props: {
        'lock_client': {
            type: Boolean,
            required: false,
            default: false
        },
        'client_id': {
            type: String,
            required: false,
            default: null
        },
        'add_enabled': {
            type: Boolean,
            required: false,
            default: true
        },
        'show_client': {
            type: Boolean,
            required: false,
            default: true
        },
        'show_location': {
            type: Boolean,
            required: false,
            default: true
        },
        'filter_org': {
            type: Boolean,
            required: false,
            default: true
        },
        'open_qr_search': {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
            families: i_families,
            db: 'registry',
            data:  {},
            org_id: null,
            sort_asc: true,
            op_types: [],
            orgs:[],
            filter: {
                client_id: this.client_id ? this.client_id : null,
                location_id: null,
                department_id: null,
                city: null,
                search_family: [],
                search: "",
                op_type: null,
                from: 0,
                to: 0,
                uom: null,
                min: null,
                max: null
            },
            op_dialog: {
                open: false,
                instr_ids: [],
                op_id: '',
                client_id: '',
                loc_id: '',
                department_id: '',
                updating: false,
                updated: false
            },
            searching: true,
            clients: [],
            locations: [],
            w_ops: [],
            enable_ops:false,
            departments: [],
            sorting_fields: [
                {label: 'nome/codice cliente', value: ['value.name', 'value.serno', 'value.exp'], order: ['asc', 'asc']},
                {label: 'scadenza', value: ['value.exp', 'value.name', 'value.serno'], order: ['asc', 'asc']},
                {label: 'modifica', value:['value.updated', 'value.name', 'value.serno'], order: ['desc', 'asc']},
                {label: 'seriale', value: ['value.serno', 'value.name', 'value.exp'], order: ['asc', 'asc']},
                {label: 'famiglia', value: ['value.family', 'value.exp', 'value.name'], order: ['asc', 'asc']}
            ],
            sort_fields: {},
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            districts: {},
            fam_uoms: [],
            search_serno: "",
            list_type: 'instrument',
            search_qr: false
        }
    },
    async beforeMount() {
        //this.changeSelector()
        console.log('filtered_org', this.filter_org)
        // this.sort_fields = this.sorting_fields[0]
        this.districts = await this.$store.state.$pouch.get('system', "district:ITALIA")
        this.op_types = Object.values(report_type).map(item => { return { id: 'exp_'+item.id, name: item.name } })
        let filter = this.restore_history_params()
        if (this.filter_org && filterByOrg('primary', 'view_org', this.$store.state.user.roles)) {
            this.filtered_org = this.$store.state.user.org_id
        }
        if (!filter) {
            this.resetSearch()
        } else if (this.client_id && filter.client_id != this.client_id) {
            this.resetSearch()
        } else {
            this.advanced_search = true
            this.filter = Object.assign({}, this.filter, filter)
            await this.getClients()
        }
        if (this.filter.client_id) {
            await this.getLocations()
            await this.getDepartments()
        } else {
            await this.getClients()
        }
        if (this.filtered_org) {
            this.filter.org = this.filtered_org
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', this.filter.org, false)
            this.orgs = orderByFields(res, {value: ['value.name'], order: ['asc']})
        } else {
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', "organism", false)
            this.orgs = orderByFields(res, {value: ['value.name'], order: ['asc']})   
            console.log(this.orgs)
            
        }
        this.updateSearch()
        console.log("QR SEARCH",this.open_qr_search)
        this.search_qr = this.open_qr_search
    },
    watch: {
        open_qr_search() {
            this.search_qr = this.open_qr_search
        } 
    },
    methods: {
        formatDate(ts) {
            return formatDatefromTS(ts)
        },
        async getClients(){
            var selectors = ['client']
            if (this.filtered_org) { 
                selectors.push(['org', this.filtered_org])
            }
            let res = await this.searchFromDesignNew('registry/searchByData', 'all_keys', selectors, false)

            this.clients = this.orderBy(res, {value:['value.name'], order: ['asc']})
            //console.log('CLIENTS', this.clients)
        },
        async getDepartments() {
            if (this.filter.location_id) {
                let location = await this.$store.state.$pouch.get("registry", this.filter.location_id)
                this.departments = Object.values(location.departments)
                this.filter.district = null
            } else {
                this.filter.department_id = null
                this.departments = []
            }
        },
        async getLocations() {
            let res = await this.searchFromDesignNew('registry/searchByData', 'key', ["client", this.filter.client_id], false)
            this.locations = this.orderBy(res, {value:['value.name'], order: ['asc']})
            if (this.locations.length == 1) {
                this.filter.location_id = this.locations[0]._id
                this.filter.district = null
            }
        },
        updateUoms(){
            if (this.filter.search_family.length == 1) {
                this.fam_uoms = this.families[this.filter.search_family[0]].uoms
            }
        },
        async saveOperation() {
            try {
                this.op_dialog.updating = true
                let op = await this.$store.state.$pouch.get('operations', this.op_dialog.op_id)
                op.instrument_ids = _.union(op.instrument_ids, this.op_dialog.instr_ids)
                if (this.op_dialog.department_id) {
                    //console.log('DEPARTMENT', this.op_dialog.department_id)
                    op.department_ids = _.union(op.department_ids, [this.op_dialog.department_id])
                }
                op.updated_by = this.$store.state.user._id
                op.updated = (new Date()).getTime()
                let opRes = await this.$store.state.$pouch.put('operations', op)
                this.op_dialog.updated = true
            } catch(error) {
                console.log('error', error)
            }
        },

        newOperation(){
            let query = {
                client_id: this.filter.client_id,
                location_id: this.filter.location_id,
                department_id: this.filter.department_id,
                instr_ids: [],
                back: this.$router.history.current.fullPath
            }
            if (this.op_dialog.open) {
                query.instr_ids = this.op_dialog.instr_ids
                query.client_id = this.op_dialog.instr.value.client_id
                query.location_id = this.op_dialog.instr.value.location
                query.department_id = this.op_dialog.instr.value.department
                this.op_dialog.open = false
            }
            this.$router.push({path: "/operations/edit", query: query})
        
        },

        editOperation(){
            this.$router.push({path: "/operations/details", query: {
                op_id: this.op_dialog.op_id,
                instr_ids: this.op_dialog.instr_ids,
                back: this.$router.history.current.fullPath
                }
            })
            this.closeOperationDialog()
        },
        closeOperationDialog() {
            this.op_dialog.loc_id = null
            this.op_dialog.client_id = null
            this.op_dialog.instr_ids = []
            this.op_dialog.department_id = []
            this.op_dialog.instr = null
            this.op_dialog.updating = false
            this.op_dialog.updated = false
            this.op_dialog.op_id = ''
            this.op_dialog.open = false
        },
        async openOperationDialog(instr) {
            // console.log('INSTR', instr)
            this.op_dialog.loc_id = instr.value.location
            this.op_dialog.client_id = instr.value.client_id
            this.op_dialog.instr_ids = [instr._id]
            if (instr.department_id){
                this.op_dialog.department_id = instr.department_id
            }
            this.op_dialog.instr = instr
            this.op_dialog.loc = this.$store.state.$pouch.get('registry', instr.value.location)
            let ops = await searchDesign(this.$store.state.$pouch, 'operations', 'operations/searchByData', 'all_keys', [['org', this.$store.state.user.org_id],['location', this.op_dialog.loc_id], ['status', 'working']], false)
            let ops_w = await searchDesign(this.$store.state.$pouch, 'operations', 'operations/searchByData', 'all_keys', [['org', this.$store.state.user.org_id], ['location', this.op_dialog.loc_id], ['status', 'created']], false)
            ops = _.union(ops, ops_w)
            if (ops && ops.length>0) {
                ops = ops.map(item => { return { _id: item.id, value: item.value } })
                ops = ops.filter((op) => {
                    //console.log("OP_TYPE", op.value.op_type, Object.keys(this.families[instr.value.family].report).includes(op.value.op_type))
                    //return true
                    return !op.value.op_type || Object.keys(this.families[instr.value.family].report).includes(op.value.op_type)
                })
                this.w_ops = orderByFields(ops, {value: ['value.order_nr', 'value.updated'], order: ['asc', 'asc']})
                //console.log('res -', this.w_ops)
            
            } else {
                this.w_ops = []
            }
            this.op_dialog.open = true
        },
        async updateClient() {
          if (this.filter.client_id) {
              await this.getLocations()
            } else {
                this.filter.location_id = null
                this.filter.department_id = null
                this.locations = []
                this.departments = []
            }
        },
        editInstrument(instr_id) {
            //this.$router.push({path: '/instrument/edit'})
            this.initDialogData(instr_id)
            this.$refs.list_instrumentEdit.openDialog(this.data);
        },
        resetSearch(){
            this.filter = {
                client_id: this.client_id ? this.client_id : null,
                location_id: null,
                department_id: null,
                city: null,
                search_family: [],
                search: "",
                op_type: null,
                from: null,
                to: null
            }
            this.search_serno = ""
            this.$store.commit('setSearchParam', {path: this.$router.history.current.fullPath, filter: null, page:1, sort_fields: this.sorting_fields[0]})
        },
        async exactSearch() {
            this.objects = await this.searchFromDesignNew('instruments/searchByData', 'key', ['serno', this.search_serno.trim()], false)
        },
        initDialogData(instr_id){
            this.data = {
                client_id: this.filter.client_id,
                location_id: this.filter.location_id,
                department_id: this.filter.department_id,
                primary: false,
                lock_client: this.lock_client,
                instrument_id: null
            }
            if (instr_id) {
                this.data.instrument_id = instr_id
            }
        },
        periodChange(f_days, t_days) {
            let now = (new Date()).getTime()
            this.filter.from = subDays(now, f_days).getTime()
            this.filter.to = subDays(now, t_days).getTime()
        },
        async updateSearch() {
            this.searching = true
            var selectors = ['instrument']
            this.enable_ops = false
            let f_keys = [...Array(this.filter.search_family.length)].map((_, i) => ['family', this.filter.search_family[i]])
            let multiple_fam = false
            if (f_keys.length >0) { 
                if (f_keys.length == 1 ){
                    selectors.push(f_keys[0])
                } else {
                    multiple_fam = true
                }
            }
            if (this.filter.client_id) {
                selectors.push(['client', this.filter.client_id])
            }
            if (this.filter.location_id) {
                selectors.push(['location', this.filter.location_id])
            }
            if (this.filter.department_id) {
                selectors.push(['department', this.filter.department_id])
            }
            if (this.filter.org) { // && !(this.client_id  || this.advanced_search)){
                selectors.push(['org', this.filter.org])
            }
            console.log('selectors', selectors)
            let res = await this.searchFromDesignNew('instruments/searchByData', 'all_keys', selectors, false)
            if (this.filter.district){
                let district = ''
                if ( typeof(this.filter.district) === "string") {
                    district= this.filter.district.toLowerCase()
                    let tmp = _.find(this.districts.districts, function(o) { 
                        return o.name.toLowerCase() == district 
                    });
                    if (tmp) {
                        district = tmp.id.toLowerCase()
                    }
                } else {
                    district= this.filter.district.id.toLowerCase()
                }
                let loc_dist = await this.searchFromDesignNew('registry/searchByData', 'key', ['district', district], false)
                let d_search = [...Array(loc_dist.length)].map((_, i) => ['location', loc_dist[i]._id])
                let d_instrs = await this.searchFromDesignNew('instruments/searchByData', 'keys', d_search, false)
                res = _.intersectionWith(res, d_instrs, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }

            //************************************************************************* */
            if (this.filter.city){
                let city = ''
                if ( typeof(this.filter.city) === "string") {
                    city = this.filter.city.toLowerCase()
                    let tmp = _.find(this.districts.cities, function(o) { 
                        return o.name.toLowerCase() == city 
                    });
                    if (tmp) {
                        city = tmp.name.toLowerCase()
                    }
                } else {
                    city= this.filter.city.name.toLowerCase()
                }
                let loc_city = await this.searchFromDesignNew('registry/searchByData', 'key', ['city', city], false)
                let l_search = [...Array(loc_city.length)].map((_, i) => ['location', loc_city[i]._id])
                let l_instrs = await this.searchFromDesignNew('instruments/searchByData', 'keys', l_search, false)
                res = _.intersectionWith(res, l_instrs, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }
            /***************************************************************************** */

            if (multiple_fam) {
                let f_instrs = await this.searchFromDesignNew('instruments/searchByData', 'keys', f_keys, false)
                //console.log("fam search" ,f_instrs)
                res = _.intersectionWith(res, f_instrs, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
                // console.log('intersection', res)
            }
            /*if (this.filter.search_family.length == 1) {
                let r_sel = []
                switch(this.filter.search_family[0]) {
                    case 'bilancia nawi':
                        if (this.filter.min){
                            r_sel[0] = ['max', this.filter.uoms, this.filter.min]
                        }
                        if (this.filter.max) {
                            r_sel[1] = ['max', this.filter.uoms, this.filter.max]
                        } else {
                            r_sel[1] = ['max', this.filter.uoms, {}]
                        }
                        break;
                    default:
                        if (this.filter.min){
                            r_sel[0] = ['max', this.filter.uoms, this.filter.min]
                        }
                        if (this.filter.max) {
                            r_sel[1] = ['max', this.filter.uoms, this.filter.max]
                        } else {
                            r_sel[1] = ['max', this.filter.uoms, {}]
                        }
                        break;
                }
                let res_date = await this.searchFromDesignNew('instruments/searchByData', 'range', [[exp_type, sd_from], [exp_type, ed_to]], false)
                res = _.intersectionWith(res, res_date, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }*/
            if (this.filter.from || this.filter.to) {
                let from = 0
                let d_to = new Date()
                d_to.setFullYear(d_to.getFullYear() + 50)
                let to = d_to.getTime()
                if (this.filter.from) {
                    from = this.filter.from
                }
                if (this.filter.to) {
                    to = this.filter.to
                }
                let sd_from = startOfDay(from).getTime()
                let ed_to = endOfDay(to).getTime()
                let exp_type = this.filter.op_type ? this.filter.op_type : 'exp'
                let res_date = await this.searchFromDesignNew('instruments/searchByData', 'range', [[exp_type, sd_from], [exp_type, ed_to]], false)
                res = _.intersectionWith(res, res_date, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }



            if (this.filter.search) {
                let text_res = await this.searchFromDesignNew('instruments/searchByText', 'text', this.filter.search, false)
                res = _.intersectionWith(res, text_res, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }
            if (!useRemoteConnection(this.$store.state.user.roles)) {
                try {
                    let a_support_ids = await this.$store.state.$pouch.allDocs(support_db)
                    let support_ids = _.map(a_support_ids.rows, 'id');
                    res = _.filter(res, function(instr) { 
                        return _.indexOf(support_ids, instr.value.client_id) >=0 && _.indexOf(support_ids, instr.value.location) >= 0
                    });
                } catch (exception) {
                    console.log('SUPPORTDB exception', exception)
                }
            }
            this.objects = this.orderBy(res, this.sort_fields)

            if (this.filter.location_id) {
                this.enable_ops = true
            }
            this.searching = false
        },
        async updateInstrument(instr_id) {
            let instr = await this.searchFromDesignNew('instruments/searchByData', 'key', instr_id, false)
            // console.log(instr)
            let idx = _.findIndex(this.objects, function(o) { return o._id == instr_id });
            if (instr.length > 0 ) {
                if (idx != -1){
                    this.objects[idx] = instr[0]
                }
            }
        },
        async refreshInstrument() {
            // this.sort_fields = this.sorting_fields[0]
            await this.updateSearch()
        },
        goToInstrument(i_id) {
            this.closeQRSearchDialog()
            if (i_id) {
                this.$router.push({path: "/instruments/details", query: {i_id: i_id, lock_client: this.lock_client, back: this.$router.history.current.fullPath}})
            } else {
                this.editInstrument(null)
            }
        },
        closeQRSearchDialog() {
            this.search_qr = false
        },
    }
}
</script>

<style>

</style>
